import { render, staticRenderFns } from "./shareActivitySubmit.vue?vue&type=template&id=ee2c7280&scoped=true"
import script from "./shareActivitySubmit.vue?vue&type=script&lang=js"
export * from "./shareActivitySubmit.vue?vue&type=script&lang=js"
import style0 from "./shareActivitySubmit.vue?vue&type=style&index=0&id=ee2c7280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2c7280",
  null
  
)

export default component.exports